module.exports = __webpack_public_path__ + "media/application/images/ui/filter-dropdown-a6f72b09acf160d9144fbd2cf423dfdb.svg";